export const deliveries = state => state.deliveries
export const countStatus = state => state.countStatus
export const deliverySelected = state => state.deliverySelected
export const saveTabSelected = state => state.saveTabSelected
